require('bootstrap/js/dist/modal');
require('bootstrap/js/dist/tooltip');
require('bootstrap-select/js/bootstrap-select');
$(function () {
    // Show/hide top menu for md
    $('.nav-item').on('click', function () {
        $('#menu_wrapper .menu .dropdown .dropdown-content').css('display','none');
        $('#menu_wrapper .menu .dropdown:hover .dropdown-content').css('display','block');
    });
    $('#menu_wrapper').on('mouseleave', function () {
        $('#menu_wrapper .menu .dropdown .dropdown-content').css('display','none');
    });

    $('.search-icon').on('click', function () {
        $(this).prev('form').submit();
    });

    // Hide top menu for sm on focus out
    $('#menu_sm').on('focusout', function () {
        // $('#header_sm').removeClass('top-menu-sm-on');
    });


    window.confirmModal = function(message, form) {
        let modal;
        modal = $('<div class="modal" tabindex="-1" role="dialog">\n' +
            '  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" role="document">\n' +
            '    <div class="modal-content">\n' +
            '      <div class="modal-body">\n' +
            '        <p>' + message + '</p>\n' +
            '      </div>\n' +
            '      <div class="modal-footer">\n' +
            '        <button  type="button" class="confirm btn btn-uplay text-white"><i class="far fa-check-circle fa-2x"></i></button>\n' +
            '        <button type="button" class="btn btn-secondary text-text-white" data-bs-dismiss="modal"><i class="far fa-times-circle fa-2x"></i></button>\n' +
            '      </div>\n' +
            '    </div>\n' +
            '  </div>\n' +
            '</div>');
        modal.find('.confirm').on('click', function () {
            form.submit();
        });
        // console.log(modal);
        modal.modal('show');
    };

    $('form[data-confirm] img, form[data-confirm] span').on('click', function (e) {
        $(this).closest('form').submit();

    });
    $('form[data-confirm]').on('submit', function (e) {
        e.preventDefault();
        let form = this;
        let message = $(this).data('confirm');
        confirmModal(message, form);

    });


    $('form .rating').on('mousedown', function (e) {
        ratingLive(this,e);
        $(this).on('mousemove', function (e) {
            ratingLive(this,e);
        });
        $(this).on('mouseup', function (e) {
            ratingSet(this,ratingLive(this,e));
        });
    });
    function ratingLive(t,e){
        let width = $(t).width();
        let position = e.pageX - $(t).offset().left;
        let percent = Math.ceil(position / width * 100);
        $(t).prev().html(Math.ceil10(5*percent/100,-1));
        return percent;
    }
    function ratingSet(t,percent){
        let $form = $(t).closest('form');
        let form = $form.get(0);
        let input = document.createElement('input');//prepare a new input DOM element
        input.setAttribute('type', 'hidden');
        input.setAttribute('value', 'percent');
        input.setAttribute('name', 'percent');
        form.appendChild(input);
        confirmModal($form.data('message'), form);
    }

    function decimalAdjust(type, value, exp) {
        // If the exp is undefined or zero...
        if (typeof exp === 'undefined' || +exp === 0) {
            return Math[type](value);
        }
        value = +value;
        exp = +exp;
        // If the value is not a number or the exp is not an integer...
        if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
            return NaN;
        }
        // Shift
        value = value.toString().split('e');
        value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
        // Shift back
        value = value.toString().split('e');
        return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
    }

// Decimal round
    if (!Math.round10) {
        Math.round10 = function(value, exp) {
            return decimalAdjust('round', value, exp);
        };
    }
// Decimal floor
    if (!Math.floor10) {
        Math.floor10 = function(value, exp) {
            return decimalAdjust('floor', value, exp);
        };
    }
// Decimal ceil
    if (!Math.ceil10) {
        Math.ceil10 = function(value, exp) {
            return decimalAdjust('ceil', value, exp);
        };
    }

});
